const messages = {
    en: {
      users: "Users",
    },
    ru: {
      users: "Пользователи",
    }
  };

  export default messages;